import { render, staticRenderFns } from "./_base-custom-select.vue?vue&type=template&id=5b077e64&scoped=true"
import script from "./_base-custom-select.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-custom-select.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-custom-select.vue?vue&type=style&index=0&id=5b077e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b077e64",
  null
  
)

export default component.exports